import React from "react";
import { useState, useEffect, useRef } from "react";
import { classNames } from "../../../misc/styling";
import { XIcon } from "@heroicons/react/solid";

const Text = ({ initText, accessToken, table, colId, editable, colTitle, thisRowIndex, totalRows, editId, onCellChange, rowId }) => {
  const [text, setText] = useState(initText || "");
  const [showExpanded, setShowExpanded] = useState(false);
  const [panelPosition, setPanelPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartOffset, setDragStartOffset] = useState({ x: 0, y: 0 });
  const textContainerRef = useRef(null);
  const panelRef = useRef(null);


  const handleMouseDown = (e) => {
    if (e.button !== 0) return;
    setIsDragging(true);
    setDragStartOffset({
      x: e.clientX - panelPosition.x,
      y: e.clientY - panelPosition.y,
    });
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return;
      setPanelPosition({
        x: e.clientX - dragStartOffset.x,
        y: e.clientY - dragStartOffset.y,
      });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, dragStartOffset]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target) &&
        textContainerRef.current && !textContainerRef.current.contains(event.target)) {

        if (editable && initText !== text) {
          onCellChange(rowId, colId, text);
        }
        setShowExpanded(false);

      }
    };

    if (showExpanded) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showExpanded, text]);

  const openPanel = () => {
    if (textContainerRef.current) {
      setPanelPosition({
        x: textContainerRef.current.offsetLeft + textContainerRef.current.offsetWidth + 5,
        y: textContainerRef.current.offsetTop,
      });
    }
    setShowExpanded(true);
  };

  useEffect(() => {
    setText(initText || "");
  }, [initText]);

  return (
    <>
      <div
        ref={textContainerRef}
        className=" group cursor-pointer border-2 border-transparent hover:border-blue-500 rounded-md  transition-all duration-150 ease-in-out px-2 py-1 h-full flex items-center w-full"
        onClick={openPanel}
      >
        <p className="text-left truncate w-full">{text}</p>
      </div>

      {showExpanded && (
        <div
          ref={panelRef}
          style={{
            position: "absolute",
            zIndex: 1000,
            left: `${panelPosition.x}px`,
            top: `${panelPosition.y}px`,
            cursor: isDragging ? "grabbing" : "default",
          }}
          className="bg-gray-100 shadow-md rounded-lg"
        >
          <div className="py-5 px-7 sm:px-9 sm:py-7">
            <div
              className="flex justify-between items-center mb-2 pb-2 border-b border-gray-200"
              style={{ cursor: "grab" }}
              onMouseDown={handleMouseDown}
            >
              <h3 className="text-lg font-medium text-gray-900 select-none">
                Edit Text
              </h3>
              <button
                onClick={() => {
                  if (editable && initText !== text) {
                    onCellChange(rowId, colId, text);
                  }
                  setShowExpanded(false);
                }}
                className="text-gray-400 hover:text-gray-600"
                onMouseDown={(e) => e.stopPropagation()}
              >
                <XIcon className="h-5 w-5" />
              </button>
            </div>
            <div className="mt-2 overflow-y-auto max-h-[70vh] w-[400px]">
              {editable ? (
                <textarea
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  rows={10}
                  className={classNames(
                    "shadow-sm w-full block sm:text-sm rounded-md border-gray-300 focus:ring-blue-500 focus:border-blue-500 bg-white"
                  )}
                  placeholder="Edit text..."
                />
              ) : (
                <div className="bg-white p-3 rounded-md shadow-sm">
                  <p className="text-gray-900 text-left whitespace-pre-line select-none">
                    {text}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Text;
